// Shared by the early prerender script and App's loading branch. This reads
// session presence only; authentication/refresh/redirect logic stays unchanged.
export function getLandingBootState(pathname, storage = undefined) {
  try {
    storage ??= window.localStorage;
    const hasSession = Boolean(storage.getItem('busiconn_access_token') || storage.getItem('busiconn_refresh_token'));
    const theme = storage.getItem('theme') === 'light' ? 'light' : 'dark';
    const showDuringAuth = pathname === '/' && !hasSession;
    return { showDuringAuth, keepPrerenderedContent: showDuringAuth && theme === 'dark' };
  } catch {
    // Restricted storage must not turn an authenticated loading view into a
    // public landing page. Fall back to the existing loader.
    return { showDuringAuth: false, keepPrerenderedContent: false };
  }
}
